import { render, staticRenderFns } from "./buildingSelectBox.vue?vue&type=template&id=006751b6&scoped=true&"
import script from "./buildingSelectBox.vue?vue&type=script&lang=js&"
export * from "./buildingSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006751b6",
  null
  
)

export default component.exports